import { z } from "zod";

import { ReferrerInformationDocumentType } from "@/src/models/constants/document-types";
import { DatabaseDefaults } from "@/src/models/database-defaults";
import { Patient, patientSchema } from "@/src/models/patient";

export const referrerInformationTypeDisplay: Record<ReferrerInformationDocumentType, string> = {
  [ReferrerInformationDocumentType.REFERRER_INFORMATION]: "Referrer Information",
};

export const referrerInformationSchema = z.object({
  patient: patientSchema,
});

export type ReferrerInformation = Omit<z.infer<typeof referrerInformationSchema>, "patient"> & {
  patient: Patient | null;
} & DatabaseDefaults;

export const referrerInformationShape: ReferrerInformation = {
  id: "",
  patient: null,
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  groupId: "",
};
